import { render } from "./TalronFlexFieldset.vue?vue&type=template&id=32d320ac"
import script from "./TalronFlexFieldset.vue?vue&type=script&lang=js"
export * from "./TalronFlexFieldset.vue?vue&type=script&lang=js"

import "./TalronFlexFieldset.vue?vue&type=style&index=0&id=32d320ac&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__